import { createSelector } from "@reduxjs/toolkit";
import { selectOrderArticlesFromVouchersV2 } from "../../vouchersV2/selectors/selectOrderArticlesFromVouchersV2.tsx";

export const selectVoucherOrderItems = createSelector([selectOrderArticlesFromVouchersV2], (orderArticleVouchersV2) => {
  return [...orderArticleVouchersV2];
});
